/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Type_Never_WaitsInputs */

const en_task_catalog_type_never_waits = /** @type {(inputs: Task_Catalog_Type_Never_WaitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never waits`)
};

const pt_br2_task_catalog_type_never_waits = /** @type {(inputs: Task_Catalog_Type_Never_WaitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca fica em espera`)
};

/**
* | output |
* | --- |
* | "Never waits" |
*
* @param {Task_Catalog_Type_Never_WaitsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_type_never_waits = /** @type {((inputs?: Task_Catalog_Type_Never_WaitsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Type_Never_WaitsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_type_never_waits(inputs)
	return pt_br2_task_catalog_type_never_waits(inputs)
});